import React, { useContext } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';
import Text from 'components/Text/Text';
import { Item } from './Item';
import classNames from 'classnames';
import style from './index.module.scss';

export const ModifiersByRestaurantList: React.FC = () => {
	const { modifiersByRestaurant } = useContext<IModifiersContext>(ModifiersContext);

	const modifierHeadingClasses = classNames(style.modifier, style.heading);
	const stopStatusHeadingClasses = classNames(style.stopStatus, style.heading);
	const restrictedStatusHeadingClasses = classNames(style.restrictedStatus, style.heading);
	const forceDisabledStatusHeadingClasses = classNames(style.forceDisabledStatus, style.heading);
	const priceHeadingClasses = classNames(style.price, style.heading);
	const articleNumberHeadingClasses = classNames(style.articleNumber, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={modifierHeadingClasses}
					translationNameSpace="listing"
					translationKey="modifierLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={stopStatusHeadingClasses}
					translationNameSpace="listing"
					translationKey="stopStatusLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restrictedStatusHeadingClasses}
					translationNameSpace="listing"
					translationKey="isRestrictedStatusLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={forceDisabledStatusHeadingClasses}
					translationNameSpace="listing"
					translationKey="isForceDisabledStatusLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={priceHeadingClasses}
					translationNameSpace="listing"
					translationKey="priceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleNumberHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{modifiersByRestaurant.items.map((item, index) => (
				<Item data={item} key={item.id + 'list'} index={index} />
			))}
		</div>
	);
};
